/**
 * Sign In Page
 *
 * Authentication entry point with dark laboratory aesthetic
 */

import { SignIn as ClerkSignIn } from '@clerk/clerk-react';
import styles from './Auth.module.css';

export function SignIn() {
  return (
    <div className={styles.authPage}>
      <div className={styles.authContainer}>
        <div className={styles.logoSection}>
          <img src="/logo.png" alt="AxLabs" className={styles.logo} />
          <span className={styles.tagline}>Virtual Science Laboratory</span>
        </div>
        <ClerkSignIn
          forceRedirectUrl="/experiments"
          appearance={{
            elements: {
              rootBox: {
                width: '100%',
                maxWidth: '400px',
              },
              card: {
                backgroundColor: '#0a0a0a',
                border: '1px solid #1a1a1a',
                boxShadow: 'none',
              },
              headerTitle: {
                display: 'none',
              },
              headerSubtitle: {
                display: 'none',
              },
            socialButtonsBlockButton: {
              backgroundColor: '#111',
              border: '1px solid #222',
              color: '#e5e5e5',
              '&:hover': {
                backgroundColor: '#1a1a1a',
              },
            },
            dividerLine: {
              backgroundColor: '#222',
            },
            dividerText: {
              color: '#666',
            },
            formFieldLabel: {
              color: '#888',
            },
            formFieldInput: {
              backgroundColor: '#111',
              border: '1px solid #222',
              color: '#e5e5e5',
              '&:focus': {
                borderColor: '#3ecf8e',
              },
            },
            formButtonPrimary: {
              backgroundColor: '#3ecf8e',
              color: '#000',
              '&:hover': {
                backgroundColor: '#34b87c',
              },
            },
            footerActionLink: {
              color: '#3ecf8e',
            },
            footerActionText: {
              color: '#666',
            },
            identityPreviewEditButton: {
              color: '#3ecf8e',
            },
            footer: {
              '& + div': {
                color: '#444',
              },
            },
          },
          variables: {
            colorPrimary: '#3ecf8e',
            colorBackground: '#0a0a0a',
            colorText: '#e5e5e5',
            colorTextSecondary: '#888',
            colorInputBackground: '#111',
            colorInputText: '#e5e5e5',
            borderRadius: '6px',
          },
        }}
      />
      </div>
    </div>
  );
}
